import React from "react";
import * as Cookies from "js-cookie";

import "./AddApplicationBaloonContent.css";
import { Icon } from "../../../Icon/Icon";

export const AddApplicationBaloonContent = ({
  setSelectedApp,
  setAddApplicationDisplay,
  setAddApplicationBaloon,
  allowedApps,
}) => {
  const accessLevel = Cookies.get("access_level");
  return (
    <div className="AddApplicationBaloonContent">
      {(accessLevel === "SUPERADMIN" || allowedApps?.includes("WORKFLOW")) && (
        <Item
          icon="iconWorkflow"
          name="Workflow"
          onClick={() => {
            setSelectedApp("WORKFLOW");
            setAddApplicationDisplay(true);
            setAddApplicationBaloon(false);
          }}
        />
      )}
      {(accessLevel === "SUPERADMIN" || allowedApps?.includes("INVENTORY")) && (
        <Item
          icon="iconInventory"
          name="Inventory"
          onClick={() => {
            setSelectedApp("INVENTORY");
            setAddApplicationDisplay(true);
            setAddApplicationBaloon(false);
          }}
        />
      )}
    </div>
  );
};

const Item = ({ icon, name, onClick }) => (
  <div className="AddApplicationBaloonContent__item" onClick={onClick}>
    <div className="AddApplicationBaloonContent__item-icon">
      <Icon name={icon} width={20} height={20} />
    </div>
    <div className="AddApplicationBaloonContent__item-name">{name}</div>
  </div>
);
